import base from './base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import {
	
	encryptWithAes,
	generateAesKey,
	
} from '@/utils/crypto';
import keyList from '@/config/key.json';
const aesKey = generateAesKey();

const parkinglot = {
    //出口获取code
    getDoorCode(id) {
        return axios.get(`${base.url}${base.path}/door/` + id);
    },
    //出口未获取到记录下单接口
    noRecOrder(data) {
        return axios.post(`${base.url}${base.path}/order/keyTopAddOrder`, data);
    },

    // 获取停车场信息
    getParkinglotInfo(id) {
        
        return axios.get(`${base.url}${base.path}/parkinfo/` + id);
    },
    // 获取停车场信息
    getXcxParkinglotInfo(id) {
        
        return axios.get(`${base.url}${base.path}/parkinfo/` + id);
    },
        // 获取补缴信息
        getVehicleOrder(params) {
        
            return axios.get(`${base.url}/api/order/getVehicleOrder?plateno=${params.plateno}&parkinglotId=${params.parkinglotId}`);
        },
    // 文化宫小程序获取停车场信息
    getParkingInfo(parkinglotId,areaId) {
        let params = {
            parkinglotId:parkinglotId,
            areaId:areaId,
            appId:keyList.Park_Info_App_Id,
          
        }
        console.log(aesKey,'aesKey');
        // return axios.get(`${base.url}${base.path}/webApi/encrypt/park/info?id=`+encryptWithAes(id, aesKey) +"&appId="+encryptWithAes(keyList.Park_Info_App_Id, aesKey) ,{
        return axios.get(`${base.url}/webApi/encrypt/park/info?body=`+encryptWithAes(JSON.stringify(params), aesKey)  ,{
            isEncrypt:true,
            merId :"10002211252"
        })
    },
   

    // 获得出场纪录
    getOutdoorRecord(id) {
        return axios.get(`${base.url}${base.path}/parkrec/pendingCar?outDoor=` + id);
    },
    // 获取记录
    getRecord(id) {
        return axios.get(`${base.url}${base.path}/parkrec/` + id);
    },
    // 通过车牌号获取记录
    getRecordByPlateNo(plateNo, id) {
        return axios.get(`${base.url}${base.path}/parkrec/venue?plateno=` + plateNo + "&parkinglotId=" + id);
    },
    // 无牌车入场出场
    noPlateManual(parkinglotId, isEntry, doorId, isIn, isOpenId, openId, buyId, areaId, interfaceManner) {
       
        if (interfaceManner == 1) 
        base.newPath = '/api/iot';
    
        if (isOpenId) {
            if (isEntry) {
                return axios.post(`${base.url}${base.newPath}/parkrec/noPlateManual`, {
                    parkinglotId: parkinglotId,
                    plateno: "无牌车",
                    inDoor: doorId,
                    isIn: isIn,
                    openId: openId,
                    areaId
                });
            } else {
                return axios.post(`${base.url}${base.newPath}/parkrec/noPlateManual`, {
                    parkinglotId: parkinglotId,
                    plateno: "无牌车",
                    outDoor: doorId,
                    isIn: isIn,
                    openId: openId,
                    areaId
                });
            }
        } else {
            if (isEntry) {
                return axios.post(`${base.url}${base.newPath}/parkrec/noPlateManual`, {
                    parkinglotId: parkinglotId,
                    inDoor: doorId,
                    plateno: "无牌车",
                    isIn: isIn,
                    buyId: buyId,
                    areaId
                });
            } else {
                return axios.post(`${base.url}${base.newPath}/parkrec/noPlateManual`, {
                    parkinglotId: parkinglotId,
                    outDoor: doorId,
                    plateno: "无牌车",
                    isIn: isIn,
                    buyId: buyId,
                    areaId
                });
            }
        }
    },
    // 无牌车入场出场
    noPlateManualInput (parkinglotId, isEntry, doorId, isIn, isOpenId, openId, buyId, areaId, interfaceManner,plateno) {
        console.log(interfaceManner);
        if (interfaceManner == 1) 
        base.newPath = '/api/iot';
        console.log(base.newPath,'定义接口');
        if (isOpenId) {
            if (isEntry) {
                // return axios.post(`${base.url}${base.newPath}/parkrec/noPlateManualInput`, {
                return axios.post(`${base.url}/api/iot/parkrec/noPlateManualInput`, {
                    parkinglotId: parkinglotId,
                    plateno: plateno,
                    inDoor: doorId,
                    isIn: isIn,
               
                    areaId
                });
            } else {
                return axios.post(`${base.url}/api/iot/parkrec/noPlateManualInput`, {
                    parkinglotId: parkinglotId,
                    plateno: plateno,
                    outDoor: doorId,
                    isIn: isIn,
             
                    areaId
                });
            }
        } else {
            if (isEntry) {
                return axios.post(`${base.url}/api/iot/parkrec/noPlateManualInput`, {
                    parkinglotId: parkinglotId,
                    inDoor: doorId,
                    plateno: plateno,
                    isIn: isIn,
                    buyId: buyId,
                    areaId
                });
            } else {
                return axios.post(`${base.url}/api/iot/parkrec/noPlateManualInput`, {
                    parkinglotId: parkinglotId,
                    outDoor: doorId,
                    plateno:plateno,
                    isIn: isIn,
                    buyId: buyId,
                    areaId
                });
            }
        }
    },

    // 测试轮询接口 进口
    test1() {
        return axios.post(`${base.url}${base.path}/parkrec/getCount?serialno=qwertyuiop01`);
    },
    test2() {
        return axios.post(`${base.url}${base.path}/parkrec/getCount?serialno=qwertyuiop02`);
    },
    test3() {
        return axios.post(`${base.url}${base.path}/parkrec/getCount?serialno=qwertyuiop03`);
    },
    test4() {
        return axios.post(`${base.url}${base.path}/parkrec/getCount?serialno=qwertyuiop04`);
    },
    // 测试计费规则
    testRules(inTime, outTime) {
        return axios.put(`http://61.139.119.236:12081/prod-api/api/feescale/test`, {
            closeTime: "2020-04-21 00:00:00",
            createBy: "admin",
            createTime: "2020-03-13 15:33:53",
            dataScope: null,
            dateRange: "2020-03-03 00:00:00至2020-04-21 00:00:00",
            dayMaxMoney: 10,
            effectiveTime: "2020-03-03 00:00:00",
            hoursNum: 1,
            id: 11,
            includeFree: "0",
            money: 1,
            params: {},
            parkName: "家纺城大酒店南停车场",
            parkinglotId: 14,
            pkFeescaleHourList: [{
                createBy: "admin",
                createTime: "2020-03-19 00:52:15",
                dataScope: null,
                feescaleId: 11,
                greaterEqual: "0",
                greaterMinute: 0,
                hoursNum: null,
                id: 38,
                lessEqual: "0",
                lessMinute: 30,
                money: 0,
                params: {},
                parkinglotId: null,
                remark: null,
                revision: null,
                searchValue: null,
                unit: "1",
                updateBy: "admin",
                updateTime: "2020-04-06 22:05:15"
            }, {
                createBy: "admin",
                createTime: "2020-03-19 10:10:58",
                dataScope: null,
                feescaleId: 11,
                greaterEqual: "1",
                greaterMinute: 30,
                hoursNum: null,
                id: 39,
                lessEqual: "0",
                lessMinute: 90,
                money: 5,
                params: {},
                parkinglotId: null,
                remark: null,
                revision: null,
                searchValue: null,
                unit: "1",
                updateBy: "admin",
                updateTime: "2020-04-06 22:05:23"
            }],
            pkFeescaleWeekList: [{
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 421,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "0"
            }, {
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 422,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "1"
            }, {
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 423,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "2"
            }, {
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 424,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "3"
            }, {
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 425,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "4"
            }, {
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 426,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "5"
            }, {
                createBy: null,
                createTime: null,
                dataScope: null,
                feescaleId: 11,
                id: 427,
                params: {},
                remark: null,
                revision: null,
                searchValue: null,
                updateBy: null,
                updateTime: null,
                weekNumber: "6"
            }],
            platetypeId: 1,
            platetypeName: "蓝牌小汽车",
            recalculate: "0",
            remark: null,
            searchValue: null,
            testInTime: inTime,
            testOutTime: outTime,
            updateBy: "admin",
            updateTime: "2020-04-06 21:56:52",
            week: ["一", "二", "三", "四", "五", "六", "七"],
            yxzk: "0"
        });
    },
    // 查询/扣除优惠券
    queryOrDeduct(isQuery, entId, plateno, inTime, outTime, parkHours, amount, timestamp) {
        if (isQuery) {
            var data = {
                "action": "queryCoupon",
                "entId": entId,
                "plateNo": plateno,
                "inTime": inTime,
                "outTime": outTime,
                "parkTime": parkHours,
                "parkFee": amount,
                "delete": 0,
                "timestamp": timestamp
            };
            return axios.post(`http://www.easthuaxin.com:8016/shop`, JSON.stringify(data));
        } else {
            var data = {
                "action": "queryCoupon",
                "entId": entId,
                "plateNo": plateno,
                "inTime": inTime,
                "outTime": outTime,
                "parkTime": parkHours,
                "parkFee": amount,
                "delete": 1,
                "timestamp": timestamp
            };
            return axios.post(`http://www.easthuaxin.com:8016/shop`, JSON.stringify(data));
        }
    },
    // 停车券扣除完 0元支付
    noPay(data) {
        return axios.post(`${base.url}${base.path}/pay/noPay`, data);
    },
    //安博广告获取停车场id
    getParkId(data) {
        return axios.post(`${base.url}${base.path}/anbo/init`, data);
    },
}

export default parkinglot;
